import React from 'react';
import { bool, func } from 'prop-types';

const MapLabelSettings = ({
  geoLabel,
  indexLabel,
  setGeoLabel,
  setIndexLabel,
}) => {
  return (
    <div className="map--settings-labels">
      <div className="map--settings-labels__title">Labels</div>
      <div>
        <label className="map--settings-labels__label">
          <input
            id="geoLabel"
            type="checkbox"
            style={{ margin: 0 }}
            checked={geoLabel}
            onChange={() => setGeoLabel(!geoLabel)}
          />
          <span className="map--settings-labels__text">
            Show geography labels
          </span>
        </label>
      </div>
      <div>
        <label className="map--settings-labels__label">
          <input
            id="indexLabel"
            type="checkbox"
            style={{ margin: 0 }}
            checked={indexLabel}
            onChange={() => setIndexLabel(!indexLabel)}
          />
          <span className="map--settings-labels__text">Show index labels</span>
        </label>
      </div>
    </div>
  );
};

MapLabelSettings.propTypes = {
  geoLabel: bool,
  indexLabel: bool,
  setGeoLabel: func,
  setIndexLabel: func,
};

export default MapLabelSettings;
